import { Component, inject, input, OnInit } from '@angular/core';
import { ApiClientConstant } from '@cureskin/api-client';
import { ConnectionService } from '@services/connection-service';
import {
  CallScheduledBottomsheetComponent,
} from '@shared/bottom-sheet-layouts/pending-call-bottomsheet/call-scheduled-bottomsheet/call-scheduled-bottomsheet.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-call-scheduled-banner',
  templateUrl: './call-scheduled-banner.component.html',
  standalone: true,
})
export class CallScheduledBannerComponent implements OnInit {
  readonly newUI = input<boolean>(false);
  readonly regimenClass = input<string>('');

  protected readonly ApiClientConstant = ApiClientConstant;

  private readonly conn = inject(ConnectionService);
  private readonly bottomSheet = inject(MatBottomSheet);

  user: any;
  mobileNumber: string;
  internalUser = false;

  ngOnInit(): void {
    this.user = this.conn.getActingUser();
    this.mobileNumber = this.user?.get('MobileNumber');
    this.internalUser = this.conn.isInternalUser();
  }

  bannerClick(): void {
    const bottomSheet = this.bottomSheet.open(CallScheduledBottomsheetComponent, {});
    bottomSheet.backdropClick().subscribe((): void => bottomSheet.dismiss());
  }
}
